'use client';

import {
  HomeLandingSections,
  HomeStoriesSection,
  HomeCommunitySection,
  HomeVoicesSection,
  HomeAboutSection,
  CommunityMatrimonyServices,
} from '@/components/homePageSections';

import { useState } from 'react';
import Header from '@/components/Header';
import HomeHeroSection from '@/components/HomeHeroSection';
import { vadhuVarSuchakMandalPuneQuestions } from './vadhuVarSuchakMandalPuneQuestions';
import HomeBenefits from '@/components/HomeBenefits';

const communityServices: { label: string; href?: string }[] = [
  { label: "Pune Vadhu Var Suchak" },
  { label: "Pune Vadhu Var Suchak Mandal" },
  { label: "Pune Vadhu Var Suchak Kendra" },
  { label: "Bhatrumandal Pune Vadhu Suchi" },
  { label: "Pune Vadhu Var Melava" },
  { label: "Pune Vivah Mandal" },
  { label: "Pune Vivah Sanstha" },
  { label: "Mali Samaj Vadhu Var Suchak Pune" },
  { label: "Shirke Vadhu Var Suchak Pune" },
  { label: "Mali Vadhu Var Suchak Pune" },
  { label: "Nimbalkar Vadhu Var Suchak Pune" },
  { label: "Kokate Vadhu Var Suchak Pune" },
  { label: "Anjali Vadhu Var Suchak Pune" },
  { label: "Dhangar Vadhu Var Suchak Pune" },
  { label: "Lingayat Vadhu Var Suchak Pune" },
  { label: "Nimbalkar Vadhu Var Suchak Pune Maharashtra" },
  { label: "Maratha Vadhu Var Suchak Pune" },
  { label: "Divorce Vadhu Var Suchak Pune" },
  { label: "Matang Vadhu Var Suchak Pune" },
  { label: "Anand Maratha Vadhu Var Suchak Pune" },
  { label: "Maratha Matrimony Pune" },
  { label: "Marathi Matrimony Pune" },
  { label: "Brahmin Matrimony Pune" },
  { label: "Divorcee Matrimony Pune" },
  { label: "Jain Matrimony Pune" },
  { label: "Dhangar Matrimony Pune" },
  { label: "Mali Matrimony Pune" },
  { label: "Lingayat Matrimony Pune" },
  { label: "Matang Matrimony Pune" },
  { label: "Marathi Matrimony Pune office address" },
  { label: "96 Kuli Maratha Matrimony Pune" },
  { label: "Leva Patil Matrimony Pune" },
  { label: "Chambhar matrimony Pune" },
  { label: "Pune matrimony" },
  { label: "Pune matrimony Whatsapp group" },
  { label: "Pune matrimony app" },
  { label: "Pune matrimony sites" },
  { label: "Pune matrimony Maratha" },
  { label: "Shubh Vivah marriage bureau Pune matrimony" },
  { label: "Aadhar Marriage Bureau Pune" },
  { label: "Aadhar Marriage Bureau Pune Pune, Maharashtra" },
  { label: "Aadhar Marriage Bureau Pune Photos" },
  { label: "Aadhar Marriage Bureau" },
  { label: "Aadhar Marriage Bureau Pune Reviews" },
  { label: "Aadhar Matrimony" },
];

export default function VadhuVarSuchakMandalPuneClient() {
  const [openFAQ, setOpenFAQ] = useState<number | null>(null);

  return (
    <div className="bg-white">
      {/* Transparent Header */}
      <Header variant="transparent" />

      <HomeHeroSection
        title="पुण्यातील मराठी वधू वरांसाठी"
        subtitle="महाराष्ट्रातील अग्रणी विवाहसंस्था"
        trackingSource="vadhu_var_suchak_mandal_pune"
      />

      <HomeLandingSections />

      <HomeStoriesSection />

      <HomeCommunitySection />

      <HomeVoicesSection />

      <HomeAboutSection />

      {/* Pune-based Marathi grooms & brides benefits on registration */}
      <HomeBenefits title="Benefits to Pune-based Marathi grooms & brides on registration:" />

      {/* FAQ Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">
            Frequently Asked Questions
          </h2>
          <div className="max-w-4xl mx-auto">
            <div className="space-y-4">
              {vadhuVarSuchakMandalPuneQuestions.map((faq, index) => (
                <div key={index} className="bg-white border border-gray-200 rounded-xl overflow-hidden shadow-sm">
                  <button
                    onClick={() => setOpenFAQ(openFAQ === index ? null : index)}
                    className="w-full px-6 py-4 text-left flex items-center justify-between hover:bg-gray-50 transition-colors"
                  >
                    <h3 className="text-lg font-semibold text-gray-900">
                      {faq.question}
                    </h3>
                    <svg
                      className={`w-5 h-5 text-gray-500 transition-transform duration-300 ${
                        openFAQ === index ? 'rotate-180' : ''
                      }`}
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  </button>
                  <div
                    className={`px-6 transition-all duration-300 ease-in-out ${
                      openFAQ === index ? 'pb-4 max-h-96 opacity-100' : 'max-h-0 opacity-0 overflow-hidden'
                    }`}
                  >
                    <div className="text-gray-600 leading-relaxed py-3">
                      <p className="mb-3">{faq.answer}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <CommunityMatrimonyServices
        title="Marathi Vadhu Var Suchak Pune Community"
        items={communityServices}
      />

    </div>
  );
}
